/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/

import { CSSProperties, memo, ReactNode } from 'react';

import { CIColors } from 'shared';

interface ChartTooltipProps {
  label: string;
  value: ReactNode;
  style?: CSSProperties;
}

export const ChartTooltip = memo<ChartTooltipProps>(({ label, value, style }) => (
  <div
    style={{
      background: 'white',
      padding: '8px 12px',
      border: '1px solid #ccc',
      borderRadius: '4px',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
      minWidth: 120,
      wordWrap: 'break-word',
      color: CIColors.Text,
      ...style,
    }}
  >
    <strong>{label}</strong>: {value}
  </div>
));
